/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MegaphoneIcon20Solid = forwardRef('MegaphoneIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M13.251 1.542C14.162.503 16 1.068 16 2.552v11.895c0 1.484-1.838 2.05-2.749 1.01-1.884-2.149-3.386-3.227-5.05-3.457H3.25A2.25 2.25 0 0 1 1 9.75v-2.5A2.25 2.25 0 0 1 3.25 5H8.2c1.665-.23 3.167-1.308 5.051-3.458Z" }),
        React.createElement("path", { d: "M8 13H4v3.5A1.5 1.5 0 0 0 5.5 18h1A1.5 1.5 0 0 0 8 16.5V13Z" }),
        React.createElement("path", { d: "M18.125 6.227A.75.75 0 0 0 17 6.876v3.248a.75.75 0 0 0 1.125.65 2.624 2.624 0 0 0 0-4.547Z" })));
});
